import { Call } from '@twilio/voice-sdk';
import AudioHelper from '@twilio/voice-sdk/es5/twilio/audiohelper';

export const hasActiveCall = (
  value: Call | null | undefined,
): value is Call => {
  if (!value) {
    console.error('[Crono VoIP] No active call.');
    return false;
  }
  return true;
};

export const hasActiveAudioHelper = (
  value: AudioHelper | null | undefined,
): value is AudioHelper => {
  if (!value) {
    console.error('[Crono VoIP] No active audio helper.');
    return false;
  }
  return true;
};
